import type { TThumbnailSize } from 'helpers/file/file.helpers.types';
import {
  getFileDisplayUrl,
  getFileDisplayUrlsInDisplayOrder,
} from 'helpers/file/fileBinary/fileBinary';

// 'resource' collections are sorted by the resources' displayOrder and drop
// unresolvable files. 'file' collections keep their order and length. Both
// accept any file resource IRI form (see fileBinary).
export type TSourceValue = 'resource' | 'file';

export const getImageUrls = async (
  images?: string | string[],
  imageType?: TSourceValue,
  thumbnailSize?: TThumbnailSize
): Promise<string | string[]> => {
  if (!images || (Array.isArray(images) && images.length === 0)) {
    return '';
  }

  if (typeof images === 'string') {
    return getFileDisplayUrl(images, thumbnailSize);
  }

  if (imageType === 'resource') {
    const urls = await getFileDisplayUrlsInDisplayOrder(images, thumbnailSize);

    // an empty list renders as an empty carousel in the ui Avatar (not even
    // the initials), so a collection where every file failed counts as none
    return urls.length > 0 ? urls : '';
  }

  return Promise.all(
    images.map((image) => getFileDisplayUrl(image, thumbnailSize))
  );
};
